module.exports = __webpack_public_path__ + "img/down_grey_arrow.c341be3b.svg";